import React from "react";
import "./problem info.css";
import {MDBContainer,MDBRow,MDBCol} from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import "react-rater/lib/react-rater.css";
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { setUser } from "../../redux/actions/AuthActions";
import { message} from "antd";
class problemInfo extends React.Component {
  
  state = {
    actionType:this.props.location.state.actionType?this.props.location.state.actionType==="EDIT"?"EDIT":"VIEW":"VIEW",
    id:this.props.location.state.data.id,
    description:this.props.location.state.data.description?this.props.location.state.data.description:allStrings.notExist,
    post:this.props.location.state.data.post?this.props.location.state.data.post:null,
    user:this.props.location.state.data.user?this.props.location.state.data.user:null,
    problemType:this.props.location.state.data.problemType?this.props.location.state.data.problemType:null,
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    categories:[]
  };

  constructor(props){
    super(props)

    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
  }
  
  componentDidMount(){
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }
  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}problems/${this.props.location.state.data.id}`,{
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.props.currentUser.token}`
    },
    })
    .then(response=>{
      l.then(() => message.success(allStrings.done, 2.5) )
      this.props.history.goBack()
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    })
  }

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROBLEMS')) return <Redirect to='/Home' />

    return (
      <div className="App">
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12" sm="12">
              <div className="infoCard">
                <Card className="editCard" style={{ overflow: "visible", outline: "none",marginBottom: "0px"}} >
                  <CardMedia style={{ height: "0px" }} />
                  <CardHeader></CardHeader>
                  <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                      <div className="topIcon" style={{background:'#117183'}}>
                          <span className="material-icons" style={{color:'white',fontproblem:23}}>star_outline</span>
                      </div>
                      <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                      marginLeft:this.props.isRTL?'0':'0',marginRight:this.props.isRTL?'0':'0'}}>
                      <p>{this.state.actionType==="VIEW"?allStrings.info:allStrings.edit}</p>
                      </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: "none" }}>
                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            noValidate
                          >
                            <div className="grey-text">
                              {this.state.actionType ==="VIEW"&&
                                  <MDBRow>
                                      <MDBCol md="12">
                                          <div className="md-form">
                                          <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>#</label>
                                          <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} required validate/>
                                          <div class="valid-feedback">{allStrings.correct}</div>
                                          <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                          </div>
                                      </MDBCol>
                                  </MDBRow>
                              }
                              <MDBRow>
                                <MDBCol md="12">
                                    <div className="md-form">
                                        <label htmlFor="form70" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.description}</label>
                                          <br></br>
                                          <textarea disabled={this.state.actionType==="VIEW"?true:false} placeholder={allStrings.description} rows="3" style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} 
                                          defaultValue={this.state.description} type="text" id="form70" className="form-control" required validate name="description"/>
                                          <div class="valid-feedback">{allStrings.correct}</div>
                                          <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                </MDBCol>
                              </MDBRow>
                              {this.state.problemType&& this.state.actionType==="VIEW"&&
                                <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                    <MDBCol md="10" xs="10">
                                        <div class="md-form">
                                        <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.problemType}</label>
                                        <br></br>
                                        <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                        <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                            {this.state.problemType?this.state.problemType.title:allStrings.notExist}
                                        </p>
                                        </div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="2" xs="2">
                                    <br></br>
                                    <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                        <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                        onClick={()=>{this.props.history.push('problemTypeInfo',{data:this.state.problemType}) }}>
                                          remove_red_eye
                                        </span>
                                        <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                          onClick={()=>{this.props.history.push('problemTypeInfo',{data:this.state.problemType}) }}>
                                          {allStrings.show}
                                        </span> 
                                      </p>
                                    </MDBCol>
                                </MDBRow>
                              }
                              {this.state.post&& this.state.actionType==="VIEW"&&
                                <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                    <MDBCol md="10" xs="10">
                                        <div class="md-form">
                                        <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.post}</label>
                                        <br></br>
                                        <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                        <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                            {this.state.post?this.state.post:allStrings.notExist}
                                        </p>
                                        </div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="2" xs="2">
                                    <br></br>
                                    <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                        <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                        onClick={()=>{this.props.history.push('postInfo',{data:{"id":this.state.post}}) }}>
                                          remove_red_eye
                                        </span>
                                        <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                          onClick={()=>{this.props.history.push('postInfo',{"id":this.state.post}) }}>
                                          {allStrings.show}
                                        </span> 
                                      </p>
                                    </MDBCol>
                                </MDBRow>
                              }
                              {this.state.user&& this.state.actionType==="VIEW"&&
                                  <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                    <MDBCol md="10" xs="10">
                                        <div class="md-form">
                                        <label htmlFor="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.user}</label>
                                        <br></br>
                                        <div style={{textAlign:this.props.isRTL?'right':'left'}}>
                                        <p style={{borderBottom: '1px solid #dedede',width:'81%',padding:'10px',paddingBottom: '14px',fontSize: '16px',fontWeight: 400,color: '#000',display: 'inline-block'}}>
                                            {this.state.user?this.state.user.fullname:allStrings.notExist}
                                        </p>
                                            <img style={{width: '50px',height: '50px',borderRadius: '50%',border:' 2px solid #117183'}} alt="" src={this.state.user.img?this.state.user.img:require('../../assets/images/profileicon.jpg')}/>
                                        </div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="2" xs="2">
                                    <br></br>
                                    <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                        <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                        onClick={()=>{this.props.history.push('userInfo',{data:this.state.user}) }}>
                                          remove_red_eye
                                        </span>
                                        <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                          onClick={()=>{this.props.history.push('userInfo',{data:this.state.user}) }}>
                                          {allStrings.show}
                                        </span> 
                                      </p>
                                    </MDBCol>
                                  </MDBRow>
                              }
                            </div>
                            <br></br>
                            <br></br>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchaddressrops = {
    setUser,
};

export default withRouter(
    connect(mapToStateProps, mapDispatchaddressrops)(problemInfo)
);